
import React from 'react';
import FeedbackManagement from '@/components/admin/FeedbackManagement';

const AdminFeedbacksPage = () => {
  
  return <FeedbackManagement />;
};

export default AdminFeedbacksPage;
